
import { addParamsToUrl, ajaxUpdatePagePart, equalizeHeightByOffset, onDelegatedClick }  from '../functions.js';

export default function ResultsPageModule(element) {

    let qs = element.querySelector.bind(element);
    let qsa = element.querySelectorAll.bind(element);

    let carContainer = qs('.car__container');

    element.addEventListener('brand-change', event => {        
        let brands = event.detail.brands;
        let url = window.location.href;
        url = addParamsToUrl(window.location.href, {
            brands: brands.join(','),
            car: ''
        });

        ajaxUpdatePagePart('#ajaxnav1', url);
        history.pushState({}, '', url);
    });

    element.changeCar = function(url, carId) {
        window.ajaxnav1.navigateTo(url);
        focusCarId(carId);
    };

    function focusCarId(carId) {
        qsa('*[data-car-id]').forEach(subelm => {
            subelm.classList.remove('active');
        });

        qsa(`*[data-car-id="${carId}"]`).forEach(subelm => {
            subelm.classList.add('active');
        });

        let carElement = qs(`.car[data-car-id="${carId}"]`);

        let centerOfScroll = carElement.offsetLeft - (carContainer.offsetWidth / 2) + (carElement.offsetWidth / 2);

        carContainer.scrollTo({
            left:     centerOfScroll,
            behavior: 'smooth'
        });
    }

}

window.modules = window.modules || {}
window.modules.ResultsPageModule = ResultsPageModule;
